export default __webpack_public_path__ + "static/media/05AW1NOV65.05933396.jpg";